<div class="content-wrapped">
    <!-- Content -->
    <div class="container-xxl flex-grow-1 container-p-y">
        <h4 class="fw-bold py-3 mb-4 text-primary">
            Tickets
        </h4>
        
        <div *ngIf="ticketinfo"  class="row">
            <div class="col-md-12">
                <div class="card mb-4">
                    <h5 class="card-header">
                        <mat-icon class="text-info align-middle">label</mat-icon> {{ ticketinfo.campana }}
                    </h5>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-6">
                                <h5>Datos de caja</h5>
                                <b>Consecutivo</b>: {{ ticketinfo.consecutivo }}
                                <br>
                                <b>Zona</b>: {{ ticketinfo.zona }}
                                <br>
                                <b>Sucursal</b>: {{ ticketinfo.sucursal }}
                                <br>
                                <b>Estatus de encuestas</b>: <span [ngClass]="getStatusSurvDat(ticketinfo.st_encuesta).class">{{getStatusSurvDat(ticketinfo.st_encuesta).nombre}}</span>
                                <br>
                                <b>Estatus de seguimiento</b>: <span [ngClass]="getStatusTrackingDat(ticketinfo.st_seguimiento).class">{{getStatusTrackingDat(ticketinfo.st_seguimiento).nombre}}</span>
                                <br>
                                <b>Responsable</b>: {{ ticketinfo.responsable }}
                                <br>
                                <b>Puesto</b>: {{ ticketinfo.puesto }}
                                <br>
                                <b>Comentarios</b>: {{ ticketinfo.comentarios }}
                                <br>
                                <button *ngIf="ticketinfo.countAdjuntos != 0" class="mt-2" mat-raised-button color="accent" (click)="verAdjuntos(ticketinfo.id_respuesta)">
                                    <mat-icon>attach_file</mat-icon> Ver Adjuntos
                                </button>
                            </div>
                            <div class="col-sm-6">
                                <h5>Datos envío</h5>
                                <b>Cantidad de productos enviados</b>: {{ ticketinfo.enviados }}
                                <br>
                                <b>Cantidad de productos con alertas</b>: {{ ticketinfo.alertas }}
                               
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
        </div>
        <!-- Card on time strategies -->
        <div class="row" [hidden]="!(dataSource?.data?.length)">
            <div class="col-md-12">
                <div class="card mb-4">
                    <h5 class="card-header">
                        <mat-icon class="text-info align-middle">stop</mat-icon> Seguimiento
                    </h5>
                    <div>
                    </div>
                    <div class="card-body">
                        <div class="overflow-auto w-200 d-flex justify-content-between">
                            <mat-form-field>
                                <mat-label>
                                    <mat-icon>search</mat-icon> Buscar</mat-label>
                                <input matInput (keyup)="applyFilter($event)" placeholder="Sobre burbuja" #input>
                            </mat-form-field>
                            <div *ngIf="haveExtras != -1" class="me-2">
                                <mat-icon class="align-middle ticket_extra">stop</mat-icon>
                                <span>
                                    Ticket extraordinario
                                </span>
                            </div>
                        </div>
                        <div class="button-cont" [hidden]="!isBuhoUsr">

                            <span [matTooltip]="'Seleccione primero los tickets que serán actualizados.'" [matTooltipDisabled]="!isNoneChecked()" [matTooltipPosition]="'above'">
                                <button mat-flat-button color="primary" [matMenuTriggerFor]="statusmenu" [disabled]="isNoneChecked()">
                                    <mat-icon>edit</mat-icon> Cambiar estatus <mat-icon>keyboard_arrow_down</mat-icon>
                                </button>
                            </span>
                            <span [matTooltip]="'Seleccione primero los tickets que serán actualizados.'" [matTooltipDisabled]="!isNoneChecked()" [matTooltipPosition]="'above'">
                                <button mat-flat-button color="primary" (click)="setLabel()" [disabled]="isNoneChecked()">
                                    <mat-icon>add</mat-icon> Asignar guía masiva
                                </button>
                            </span>
                            <mat-menu #statusmenu>
                                <button mat-menu-item *ngFor="let x of statusTicketExclude()" (click)="changeMassiveSts(x.id)">
                                    <span [ngClass]="x.class">{{ x.nombre }}</span>
                                </button>
                            </mat-menu>
                        </div>
                            <div class="mat-elevation-z0 table-responsive">
                                <table mat-table [dataSource]="dataSource" matSort class="w-100">
                        
                                    <ng-container matColumnDef="id">
                                        <th class="col-1 ps-2" mat-header-cell *matHeaderCellDef mat-sort-header> Código Ticket </th>
                                        <td class="col-1 ps-2" mat-cell *matCellDef="let row" style="max-width: 80px;"> {{row.id}} </td>
                                    </ng-container>

                                    <ng-container matColumnDef="producto">
                                        <th class="col-2 ps-2" mat-header-cell *matHeaderCellDef mat-sort-header> Producto </th>
                                        <td class="col-2 ps-2 text-primary" mat-cell *matCellDef="let row"  style="max-width: 80px; cursor: pointer; " (click)="verProducto(row.img)"> <label style="color: #03a9f4; cursor: pointer;"> {{row.producto}}</label>    <!--<span *ngIf="row.comentario != ''"  matTooltip="{{row.comentario}}"
                                            matTooltipPosition="right"  <mat-icon>info</mat-icon></span>>--></td>
                                    </ng-container>
                        
                                    <ng-container matColumnDef="comentario">
                                        <th class="col-2 ps-2" mat-header-cell *matHeaderCellDef mat-sort-header> Comentario </th>
                                        <td class="col-2 ps-2" mat-cell *matCellDef="let row" style="max-width: 50px; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; "> <span style="text-overflow: ellipsis; 
                                            overflow: hidden; 
                                            white-space: nowrap;" matTooltip="{{row.comentario}}"
                                            matTooltipPosition="right">{{row.comentario}}</span> </td>
                                    </ng-container>

                                    <ng-container matColumnDef="tipo">
                                        <th class="col-1 ps-2 pe-3" mat-header-cell *matHeaderCellDef mat-sort-header> Tipo ticket
                                        </th>
                                        <td class="col-1 ps-2 pe-3" mat-cell *matCellDef="let row">
                                            <div *ngIf="isBuhoUsr">
                                                <span *ngIf="row.tipo" [matMenuTriggerFor]="menu5" [ngClass]="getTicketsTypeDat(row.tipo).class">{{getTicketsTypeDat(row.tipo).nombre}}</span>
                                                <mat-menu #menu5="matMenu">
                                                    <button *ngFor="let stat of filterValidTickets()" (click)="updateTipoTicket(row.id, stat.id, stat.nombre)"  mat-menu-item >{{ stat.nombre }}</button>
                                                </mat-menu>
                                            </div>
                                            <div *ngIf="!isBuhoUsr">
                                                <span *ngIf="row.tipo"  [ngClass]="getTicketsTypeDat(row.tipo).class">{{getTicketsTypeDat(row.tipo).nombre}}</span>
                                            </div>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="status">
                                        <th class="col-1 ps-2" mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 60px;"> Estatus ticket 

                                        </th>
                                        <td class="col-1 ps-2" mat-cell *matCellDef="let row" style="max-width: 60px;">
                                            <ng-container *ngIf="row.tipo!=null && row.status!=4">
                                                <span [matMenuTriggerFor]="menu3" [ngClass]="getStatusTicketsDat(row.status).class">{{getStatusTicketsDat(row.status).nombre}}</span> 
                                                <mat-menu #menu3="matMenu" >
                                                    <button *ngFor="let stat of statusTicketExclude()" (click)="updateTicket(row.id, stat.id, row.producto)"  mat-menu-item ><span [ngClass]="stat.class">{{ stat.nombre }}</span></button>
                                                </mat-menu>
                                            </ng-container>
                                            <ng-container *ngIf="row.tipo==null">
                                                <span [ngClass]="'badge badge-info'">Pendiente Crear</span> 
                                            </ng-container>
                                            <ng-container *ngIf="row.status==4">
                                                <span [ngClass]="'badge badge-success'">Resuelto (Anulación)</span> 
                                            </ng-container>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="tracking">
                                        <th class="col-2 text-center" mat-header-cell *matHeaderCellDef style="max-width: 120px;"> Guía</th>
                                        <td class="col-2 text-center" mat-cell *matCellDef="let row" style="max-width: 120px;">
                                            <span [class.pointer]="row.status === 3" [matTooltip]="'Clic para editar'" [matTooltipDisabled]="row.status !== 3" [matTooltipPosition]="'above'"  (click)="row.status === 3 && showTrackingInput(row)" *ngIf="row.tracking_number && editingRow != row; else addTracking">
                                                {{row.tracking_number}}
                                            </span>
                                            <ng-template #addTracking>
                                                <ng-container *ngIf="row.status == 3; else noTracking">
                                                    <ng-container *ngIf="editingRow !== row">
                                                        <!-- TODO: VERIFICAR PERMISOS PARA VER BOTON -->
                                                        <button [hidden]="!isBuhoUsr" mat-icon-button matTooltip="Agregar guía" [matTooltipPosition]="'above'" color="accent" (click)="showTrackingInput(row)">
                                                            <mat-icon>add</mat-icon>
                                                        </button>
                                                    </ng-container>
                                                    <ng-container *ngIf="editingRow === row">
                                                        <mat-form-field appearance="standard" style="max-width: 180px;">
                                                            <mat-label>Guía</mat-label>
                                                            <input #trackingInput autocomplete="off" [(ngModel)]="newTrackingNumber" matInput (keyup.enter)="saveTrackingNumber(row)" (keyup.escape)="cancelEditing()"/>
                                                            <button matTooltip="Cancelar" matSuffix mat-icon-button (click)="cancelEditing()">
                                                                <mat-icon class="grey">close</mat-icon>
                                                            </button>
                                                            <mat-hint>Presiona enter para guardar</mat-hint>
                                                        </mat-form-field>
                                                    </ng-container>
                                                </ng-container>
                                                <ng-template #noTracking>
                                                    -
                                                </ng-template>
                                            </ng-template>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="status_guia">
                                        <th class="col-2 text-center" mat-header-cell *matHeaderCellDef style="max-width: 60px;"> Estatus guía </th>
                                        <td class="col-2 text-center" mat-cell *matCellDef="let row" style="max-width: 60px;">
                                            <span
                                                *ngIf="row.status_guia != null"
                                                [class]="'badge ' + estatusMappingTable[row.status_guia]?.color"
                                                [matTooltip]="row.message"
                                                [matTooltipPosition]="'above'"
                                                >{{
                                                estatusMappingTable[row.status_guia]?.label || row.status_guia
                                                }}
                                            </span>
                                            <div *ngIf="row.status_guia != null">
                                                <span *ngIf="isDedicated(row)" [class]="'badge bg-success'" [matTooltip]="row.message" [matTooltipPosition]="'above'">
                                                Entregado*
                                                </span>
                                            </div>
                                        </td>
                                    </ng-container>

                                    
                                    <ng-container matColumnDef="enviado">
                                        <th [hidden]="!isBuhoUsr" class="col-1 text-center" mat-header-cell *matHeaderCellDef style="max-width: 100px;">Material reenviado</th>
                                        <td [hidden]="!isBuhoUsr" class="col-1 text-center" [matTooltip]="row.enviado==1?'Enviado':'No enviado'" mat-cell *matCellDef="let row" style="max-width: 70px;">
                                            <mat-slide-toggle (change)="setEnviado(row, $event)" [checked]="row.enviado==1"> {{row.enviado==1?"Enviado":"No enviado"}} </mat-slide-toggle>
                                        </td>
                                    </ng-container>
                                    

                                    <ng-container matColumnDef="massive">
                                        <th class="col-1" mat-header-cell *matHeaderCellDef class="text-center" [hidden]="!isBuhoUsr || noSelectableIDs()"> 
                                            <mat-checkbox [checked]="isAllChecked()" [indeterminate]="isIndeterminate()" (change)="toggleAll($event.checked)" [matTooltip]="'Seleccionar todo'" [matTooltipPosition]="'above'"></mat-checkbox>  
                                        </th>
                                        <td class="col-1 ps-2" mat-cell *matCellDef="let row" style="max-width: 12px;" class="text-center" [hidden]="!isBuhoUsr">
                                            <input title="Cambio de estatus masivo"  class="form-check-input custom-checkbox" type="checkbox" [checked]="checkIfChecked(row.id)" (click)="setTicketListToEdit(row.id, $event)" *ngIf="row.tipo && row.status !=4">
                                           
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="acciones">
                                        <th class="col-1 ps-2 text-center" mat-header-cell *matHeaderCellDef> Acciones </th>
                                        <td class="col-1 ms-2 text-center" mat-cell *matCellDef="let row">
                                            <div class="d-flex ms-2">
                                                <button mat-icon-button *ngIf="row.tipo != null" color="accent" (click)="openDialogLogList(row)" [matTooltip]="'Ver detalle'" [matTooltipPosition]="'above'">
                                                    <mat-icon>remove_red_eye</mat-icon>
                                                </button>
                                                <button mat-icon-button *ngIf="row.tipo == null" color="accent" [matMenuTriggerFor]="menu4" [matTooltip]="'Crear ticket'" [matTooltipPosition]="'above'">
                                                    <mat-icon>add</mat-icon>
                                                </button>
                                                <mat-menu #menu4="matMenu">
                                                    <button mat-menu-item *ngFor="let stat of filterValidTickets()" (click)="addTicket(row.id, stat.id, row.producto, row.status_alerta)">
                                                        {{ stat.nombre }}
                                                    </button>
                                                </mat-menu>
                                                <button mat-icon-button *ngIf="row.tipo == null" color="accent" (click)="removeTicket(row.id, row.producto)" [matTooltip]="'Anular'" [matTooltipPosition]="'above'">
                                                    <mat-icon>highlight_off</mat-icon>
                                                </button>
                                            </div>
                                        </td>
                                    </ng-container>
                        
                                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                    <tr [ngClass]="{'highlight': row.extra_ticket === 1 || row.comentario === 'Extraordinario'}" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>                        
                                    <tr class="mat-row" *matNoDataRow>
                                        <td class="mat-cell" colspan="6">No hay alertas para mostrar</td>
                                    </tr>
                                </table>
                        
                                <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
                            </div>        
                    </div>
                </div>
            </div>
        </div>
        <!-- Card active campaigns strategies-->

    </div>
</div>